import { useState, type FormEvent } from "react";
import { useMe, useUpdateMe } from "../api/hooks";
import { Button, Card, ErrorBox, Field, Input } from "../components/ui";

export function SettingsPage() {
  const me = useMe();
  const nameUpdate = useUpdateMe();
  const pwUpdate = useUpdateMe();
  const [displayName, setDisplayName] = useState(me.data?.user.displayName ?? "");
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");

  function saveName(e: FormEvent) {
    e.preventDefault();
    nameUpdate.mutate({ displayName });
  }
  async function savePassword(e: FormEvent) {
    e.preventDefault();
    const ok = await pwUpdate.mutateAsync({ currentPassword: current, newPassword: next }).catch(() => null);
    if (ok) {
      setCurrent("");
      setNext("");
    }
  }

  return (
    <div className="mx-auto max-w-md space-y-4">
      <h1 className="text-xl font-semibold">Settings</h1>
      <Card>
        <form onSubmit={saveName} className="space-y-3">
          <Field label="Display name" hint={`Your username is @${me.data?.user.username}; it can't change.`}>
            <Input value={displayName} onChange={(e) => setDisplayName(e.target.value)} maxLength={32} required />
          </Field>
          <ErrorBox error={nameUpdate.error} />
          {nameUpdate.isSuccess && <p className="text-sm text-yes">Saved.</p>}
          <Button type="submit" disabled={nameUpdate.isPending}>Save</Button>
        </form>
      </Card>
      <Card>
        <form onSubmit={savePassword} className="space-y-3">
          <h2 className="font-semibold">Change password</h2>
          <Field label="Current password"><Input type="password" autoComplete="current-password" value={current} onChange={(e) => setCurrent(e.target.value)} required /></Field>
          <Field label="New password" hint="At least 6 characters. Other devices will be logged out.">
            <Input type="password" autoComplete="new-password" value={next} onChange={(e) => setNext(e.target.value)} required minLength={6} />
          </Field>
          <ErrorBox error={pwUpdate.error} />
          {pwUpdate.isSuccess && <p className="text-sm text-yes">Password changed.</p>}
          <Button type="submit" disabled={pwUpdate.isPending}>Change password</Button>
        </form>
      </Card>
    </div>
  );
}
